/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setDNavBtn.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ドロワーナビゲーションボタン
 */
const setDNavBtn = () => {
    var body = document.body;
    var DNavBtn = document.getElementById("d-nav-btn");
    var DNav = document.getElementById("site-h_d-nav");

    if (DNav) {
        var DNavLinks = DNav.querySelectorAll("a[href^='#']");
        console.log(DNavLinks);

        DNavBtn.addEventListener("click", function () {
            body.classList.toggle("open");
            DNavBtn.classList.toggle("open");
            DNav.classList.toggle("open");
        });

        DNavLinks.forEach((link) => {
            link.addEventListener("click", function () {
                body.classList.toggle("open");
                DNavBtn.classList.toggle("open");
                DNav.classList.toggle("open");
            });
        });
    } else {
        console.warn('DNav 要素が見つかりません');
    }
};

/**
 * Export.
 */
export { setDNavBtn };